/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseTicketAssignmentConfigList } from '../models/api-response-ticket-assignment-config-list';
import { getTicketAssignmentConfig } from '../fn/ticket-assignment-config-api/get-ticket-assignment-config';
import { GetTicketAssignmentConfig$Params } from '../fn/ticket-assignment-config-api/get-ticket-assignment-config';
import { updateTicketAssignmentConfig } from '../fn/ticket-assignment-config-api/update-ticket-assignment-config';
import { UpdateTicketAssignmentConfig$Params } from '../fn/ticket-assignment-config-api/update-ticket-assignment-config';

@Injectable({ providedIn: 'root' })
export class TicketAssignmentConfigApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateTicketAssignmentConfig()` */
  static readonly UpdateTicketAssignmentConfigPath = '/v1/api/ui/ticket-assignment-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTicketAssignmentConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTicketAssignmentConfig$Response(params: UpdateTicketAssignmentConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketAssignmentConfigList>> {
    return updateTicketAssignmentConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTicketAssignmentConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTicketAssignmentConfig(params: UpdateTicketAssignmentConfig$Params, context?: HttpContext): Observable<ApiResponseTicketAssignmentConfigList> {
    return this.updateTicketAssignmentConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTicketAssignmentConfigList>): ApiResponseTicketAssignmentConfigList => r.body)
    );
  }

  /** Path part for operation `getTicketAssignmentConfig()` */
  static readonly GetTicketAssignmentConfigPath = '/v1/api/ui/ticket-assignment-config/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTicketAssignmentConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicketAssignmentConfig$Response(params: GetTicketAssignmentConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketAssignmentConfigList>> {
    return getTicketAssignmentConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTicketAssignmentConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicketAssignmentConfig(params: GetTicketAssignmentConfig$Params, context?: HttpContext): Observable<ApiResponseTicketAssignmentConfigList> {
    return this.getTicketAssignmentConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTicketAssignmentConfigList>): ApiResponseTicketAssignmentConfigList => r.body)
    );
  }

}
